var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import StyledHeaderLink, { StyledHeaderButton, StyledHeaderAnchor } from "./styled/HeaderLink";
var HeaderLink = function (_a) {
    var containerProps = _a.containerProps, props = __rest(_a, ["containerProps"]);
    if (props.to) {
        return (React.createElement("div", __assign({}, containerProps),
            React.createElement(StyledHeaderLink, __assign({}, props, { height: props.height, plain: true }))));
    }
    if (props.href) {
        return (React.createElement("div", __assign({}, containerProps),
            React.createElement(StyledHeaderAnchor, __assign({}, props, { height: props.height, plain: true }))));
    }
    return (React.createElement("div", __assign({}, containerProps),
        React.createElement(StyledHeaderButton, __assign({}, props, { height: props.height }))));
};
HeaderLink.defaultProps = {
    height: 70,
    containerProps: {}
};
export default styled(HeaderLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
